import { useContactOne } from "@hooks/useContact";
import "./index.scss";
import FloatContactContent from "@pages/home/components/FloatContact/FloatContactContent";

const ContactUs = ({ type = "login" }: { type: string }) => {
  const contact = useContactOne();
  const kalo_pos = type === "login" ? "login-contact-float" : "sign-contact-float";

  if (contact) {
    return (
      <FloatContactContent
        className="Component-FloatContactContent Layout-FloatContactContent"
        kalo_pos={kalo_pos}
        groupChat={contact}
      ></FloatContactContent>
    );
  }
  return null;
};

export default ContactUs;
